import { createSelector } from '@reduxjs/toolkit';
import { ascend, prop, sortWith } from 'ramda';

const optionSort = sortWith([ascend(prop('type')), ascend(prop('optionName'))]);
export const getBrandsOptionsState = (state) => state.brandsOptions;

export const getBrandsOptionState = (state) => state.brandsOption;

export const getBrandsOptions = createSelector(
  getBrandsOptionsState,
  (optionsState) => optionsState.data && optionSort(optionsState.data),
);

export const getBrandsOptionsObj = createSelector(getBrandsOptionState, (options) => {
  if (!options.data) return null;
  return options.data.reduce((acc, option) => {
    const { optionId, optionName, type } = option;
    return { [optionId]: { optionId, optionName, type }, ...acc };
  }, {});
});
